import { environment } from '../environments/environment';

export const config = Object.freeze(environment);



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/app.config.ts